"use client"
import { PostData } from "@/types/types"
import { useState, type CSSProperties } from "react"
import type { Article } from "../types/new"
import { NewsItemCard } from "./NewsItemCard"

export function NewsSidebar({
  tabs = [],
  className = "",
  style,
}: {
  tabs?: {
    categoryId: string
    categoryName: string
    articles: Article[]
    postsData?: Map<string, PostData>
  }[]
  className?: string
  style?: CSSProperties
}) {
  const [activeTabIndex, setActiveTabIndex] = useState(0)

  // Nếu không có tab nào, không render gì
  if (!tabs || tabs.length === 0) {
    return null
  }

  const currentArticles = tabs[activeTabIndex]?.articles || []

  return (
    <aside style={style} className={`${className} flex flex-col flex-1 w-full md:pl-[20px] min-h-0 overflow-hidden`}>
      {/* Tabs header - cố định */}
      <div className="flex gap-4 text-sm font-bold bg-white flex-shrink-0">
        {tabs.map((tab, index) => (
          <button
            key={tab.categoryId}
            className={`px-2 pt-2 pb-4 transition-colors whitespace-nowrap min-w-[100px] text-[13px] leading-[1.55] hover:text-[#1EAD46] ${
              activeTabIndex === index
                ? "border-t-2 border-black/60 text-[#242F3E] font-bold -mb-[2px]"
                : "text-[#242F3E] font-normal"
            }`}
            onClick={() => setActiveTabIndex(index)}
          >
            {tab.categoryName.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Scrollable content - tự động chiếm hết chiều cao còn lại và scroll khi vượt quá */}
      <div className="overflow-y-auto flex-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent hover:scrollbar-thumb-gray-400">
        {currentArticles.map(a => (
          <NewsItemCard
            key={a.id}
            variant="sidebar"
            article={a}
            showTime
            postData={tabs[activeTabIndex]?.postsData?.get(a.id)}
          />
        ))}
      </div>
    </aside>
  )
}
